import { Button, Container, Typography } from "@mui/material";
import React from "react";

export class OuterErrorBoundary extends React.Component<any, { hasError: boolean }> {
  constructor(props: any) {
    super(props);

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI

    return { hasError: true };
  }
  componentDidCatch(error: any, errorInfo: any) {
    // You can use your own error logging service here
    console.log({ error, errorInfo });
  }
  render() {
    // Check if the error is thrown
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <React.Fragment>
          <p>Sorry, a technical error has occurred!</p>
          <button onClick={() => this.setState({ hasError: false })}>Reload</button>
        </React.Fragment>
      );
    }

    return this.props.children;
  }
}

export class InnerErrorBoundary extends React.Component<any, { hasError: boolean }> {
  constructor(props: any) {
    super(props);

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI

    return { hasError: true };
  }
  componentDidCatch(error: any, errorInfo: any) {
    // You can use your own error logging service here
    console.log({ error, errorInfo });
  }
  render() {
    // Check if the error is thrown
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Container maxWidth="xl" sx={{ pt: 12, pb: 16 }}>
          <Typography component="h1" variant="h2" sx={{ pb: 3 }}>
            A technical error has occurred
          </Typography>
          <Typography variant="body1" sx={{ pb: 5, maxWidth: "90ch" }}>
            Sorry, this should not happen. Please try reloading the page first. If that doesn&apos;t
            help, please write us a message at support@culinario-mortale.com and briefly describe which
            page you were viewing when this error occurred. Then we will look at it immediately and try
            to help you.
          </Typography>
          <Button variant="contained" onClick={() => this.setState({ hasError: false })}>
            Reload
          </Button>
        </Container>
      );
    }

    return this.props.children;
  }
}
